import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL_PAGES } from "../data/legal-data";

const PAGES = LEGAL_PAGES;

export default function LegalPage() {
    const { slug } = useParams();
    const page = PAGES[slug];
    if (!page) return <div className="min-h-screen pt-32 text-center">Not found</div>;
    return (
        <main className="pt-28 pb-20 min-h-screen" data-testid={`legal-${slug}`}>
            <div className="max-w-3xl mx-auto px-4 sm:px-8">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-aiblue mb-5"><ArrowLeft className="h-4 w-4" /> Back to home</Link>
                <h1 className="font-display font-black text-4xl sm:text-5xl tracking-normal mb-3">{page.title}</h1>
                <p className="text-sm text-gray-500 mb-10">{page.dateLabel || "Effective Date"}: {page.effectiveDate || page.lastUpdated || "April 01, 2026"}</p>
                <div className="prose prose-lg max-w-none space-y-7">
                    {
                        page.sections.map((s, i) => (
                            <section key={i}>
                                {s.h && <h2 className="font-display font-bold text-2xl mt-8 mb-2">{s.h}</h2>}
                                <p className="text-gray-700 leading-relaxed whitespace-pre-line">{s.p}</p>
                            </section>
                        ))
                    }
                </div>
            </div>
        </main>
    );
}